import z from 'zod'
import constants from '../../constants'
import { ReimbursementType } from '../enums/ReimbursementType.enum'
import ZodHelper from '../../helpers/zod.helper'
import { Currency } from '../enums/Currency.enum'

const medicalReimbursementEditSchema = z.object({
  name: z.string().min(2).optional(),
  email: z.email().optional(),
  serviceDate: z.date().optional(),
  reimbursementType: ZodHelper.zEnumFromTsEnum(ReimbursementType).optional(),
  vendor: z.string().min(2).optional(),
  description: z.string().optional(),
  totalAmountClaimed: z
    .object({
      currency: ZodHelper.zEnumFromTsEnum(Currency),
      value: z
        .string()
        .refine(val => !!val && !isNaN(Number(val)), {
          message: 'Please input number only value...',
        })
        .refine(val => Number(val) > constants.limits.minMedicalReimbursementAmount, {
          message: 'Minimum value of 1...',
        }),
    })
    .optional(),
})

export type MedicalReimbursementEditSchema = z.infer<typeof medicalReimbursementEditSchema>

export default medicalReimbursementEditSchema
